import api from '../../../services/api';
import { toast } from "react-toastify";

// Sends one push via the backend notification endpoint.
// Moved verbatim from TradeRecommendationForm's handleSendNotification.
// `query` selects the audience: 12/14/13 = paid equity/futures/options,
// 16/17/18 = free equity/futures/options.
export const sendNotification = async (
  id,                   // notification category id
  title,                // notification title
  message,              // notification body text
  query,                // audience group (see legend above)
  notificationtypeid,   // notification type (1)
  scriptTypeId,         // market segment; sent only when present
  setLoading,           // toggles the saving spinner
) => {
  if (!id) return;      // nothing to send


  try {
    setLoading(true);

    const payload = {
      id,
      title,
      message,
      query,
      notificationtypeid,
      ...(scriptTypeId ? { scriptTypeId } : {}),
    };

    const response = await api.post("/notification/send", payload);

    console.log(`sent notification ${response}`);

    toast.success(
      response.data?.message ||
      `Notification sent successfully to ${response.sent} users!`,
    );
    return;
  } catch (error) {
    console.error("Failed to send notification:", error);
    toast.error("Failed to send notification");
  } finally {
    setLoading(false);
  }
};

// Fires edit-path notifications (SL updated, target updated, target/SL hit,
// manual exit). Block moved verbatim from TradeRecommendationForm.onFormSubmit.
export const dispatchEditNotifications = ({
  formattedData,
  scriptTypeId,
  stopLossChanged,
  targetUpdated,
  targetHitTriggered,
  stopLossHitTriggered,
  manualExitTriggered,
  initialStopLoss,
  initialTargetOne,
  actualProfit,
  actualProfitpercentage,
  fetchduration,
  setLoading,
}) => {
  // Thin adapter so the moved block can call handleSendNotification exactly as
  // it did in the original (it just forwards to sendNotification with setLoading).
  const handleSendNotification = (id, title, message, query, notificationtypeid, sType) =>
    sendNotification(id, title, message, query, notificationtypeid, sType, setLoading);

  // ======================
  // STOP LOSS UPDATED
  // ======================

  //All Paid equity Users
  if (stopLossChanged && (scriptTypeId === 1)) {
    handleSendNotification(
      3,
      "SL Updated for Equity Trade",
      `Stop Loss updated for ${formattedData.script} from ${Number(initialStopLoss).toFixed(2)} to ${Number(formattedData.stopLoss).toFixed(2)}. Please update your trade if taken. Check more details in the application.`,
      12,
      1,
      scriptTypeId,
    );
  }
  //All Paid Futures Users
  else if (stopLossChanged && (scriptTypeId === 2)) {
    handleSendNotification(
      3,
      "SL Updated for Futures Trade",
      `Stop Loss updated for ${formattedData.script} from ${Number(initialStopLoss).toFixed(2)} to ${Number(formattedData.stopLoss).toFixed(2)}. Please update your trade if taken. Check more details in the application.`,
      14,
      1,
      scriptTypeId,
    );
  }
  // All Paid Options Users
  else if (stopLossChanged && (scriptTypeId === 3)) {
    handleSendNotification(
      3,
      "SL Updated for Options Trade",
      `Stop Loss updated for ${formattedData.script} from ${Number(initialStopLoss).toFixed(2)} to ${Number(formattedData.stopLoss).toFixed(2)}. Please update your trade if taken. Check more details in the application.`,
      13,
      1,
      scriptTypeId,
    );
  }

  // ======================
  // TARGET PRICE INCREASED
  // ======================
  // All Paid Equity Users
  if (targetUpdated && (scriptTypeId === 1)) {
    handleSendNotification(
      1,
      `Target Updated for Equity Trade`,
      `Target price updated for ${formattedData.script} from ${(initialTargetOne)} to ${(formattedData.targetOne)}. Update your trade if taken. Check more details in the application.`,
      12,
      1,
    );// All Free Equity Users
    handleSendNotification(
      1,
      "Target Updated for Equity Trade",
      `Target price updated by ${Math.abs(((formattedData.targetOne - initialTargetOne) / initialTargetOne) * 100).toFixed(2)}%.  Don't miss opportunities, subscribe now to get more details.`,
      16,
      1,
      scriptTypeId,
    );
  }
  // All Paid Future Users
  else if (targetUpdated && (scriptTypeId === 2)) {
    handleSendNotification(
      2,
      `Target Updated for Futures Trade`,
      `Target price updated for ${formattedData.script} from ${(initialTargetOne)} to ${(formattedData.targetOne)}. Update your trade if taken. Check more details in the application.`,
      14,
      1,
    );

    // All Free Future Users
    handleSendNotification(
      1,
      "Target Updated for Futures Trade",
      `Target price updated by ${Math.abs(((formattedData.targetOne - initialTargetOne) / initialTargetOne) * 100).toFixed(2)}%.  Don't miss opportunities, subscribe now to get more details.`,
      17,
      1,
      scriptTypeId,
    );
  }
  // All Paid Options Users
  else if (targetUpdated && (scriptTypeId === 3)) {
    handleSendNotification(
      2,
      `Target Updated for Options Trade`,
      `Target price updated for ${formattedData.script} from ${(initialTargetOne)} to ${(formattedData.targetOne)}. Update your trade if taken. Check more details in the application.`,
      13,
      1,
    );

    // ALL Free Options Users
    handleSendNotification(
      1,
      "Target Updated for Options Trade",
      `Target price updated by ${Math.abs(((formattedData.targetOne - initialTargetOne) / initialTargetOne) * 100).toFixed(2)}%. Don't miss opportunities, subscribe now to get more details.`,
      18,
      1,
      scriptTypeId,
    );
  }


  // ======================
  // TARGET HIT
  // ======================

  // for Equity Paid Users
  if (targetHitTriggered && (scriptTypeId === 1)) {
    handleSendNotification(
      1,
      "Target Hit for Equity Trade",
      `Target hit for ${formattedData.script} book profit of ₹${actualProfit.toFixed(2)} (${actualProfitpercentage.toFixed(2)}%). Check more details in the application.`,
      12,
      1,
      scriptTypeId,
    );
    // for Equity free Users
    handleSendNotification(
      1,
      "Target Hit",
      `Target hit for ${formattedData.script} premium users booked profit of ₹${actualProfit.toFixed(2)} in ${fetchduration(formattedData.tradeTypeId)}. Don't miss opportunities, subscribe now!.`,
      16,
      1,
      scriptTypeId,
    );

  }   // for futures Paid Users
  else
    if (targetHitTriggered && (scriptTypeId === 2)) {
      handleSendNotification(
        1,
        "Target Hit for Futures Trade",
        `Target hit for ${formattedData.script} book profit of ₹${actualProfit.toFixed(2)} (${actualProfitpercentage.toFixed(2)}%). Check more details in the application.`,
        14,
        1,
        scriptTypeId,
      );
      // for future free Users
      handleSendNotification(
        1,
        "Target Hit",
        `Target hit for ${formattedData.script} premium users booked profit of ₹${actualProfit.toFixed(2)}. Don't miss opportunities, subscribe now!`,
        17,
        1,
        scriptTypeId,
      );
    }   // for Options Paid Users
    else
      if (targetHitTriggered && (scriptTypeId === 3)) {
        handleSendNotification(
          1,
          "Target Hit for Options Trade",
          `Target hit for ${formattedData.script} book profit of ₹${actualProfit.toFixed(2)} (${actualProfitpercentage.toFixed(2)}%). Check more details in the application.`,
          13,
          1,
          scriptTypeId,
        );
        // for Futures free Users
        handleSendNotification(
          1,
          "Target Hit",
          `Target hit for ${formattedData.script} premium users booked profit of ₹${actualProfit.toFixed(2)}. Don't miss opportunities, subscribe now!`,
          18,
          1,
          scriptTypeId,
        );
      }



  // ======================
  // STOP LOSS HIT
  // ======================
  if (stopLossHitTriggered && (scriptTypeId === 1)) {
    // for Equity Paid Users
    handleSendNotification(
      2,
      "SL Hit for Equity Trade",
      `Stop loss hit for ${formattedData.script}. Exit your trade if taken. Check more details in the application.`,
      12,
      1,
      scriptTypeId,
    );
  }
  else if (stopLossHitTriggered && (scriptTypeId === 2)) {
    // for Futures Paid Users
    handleSendNotification(
      2,
      "SL Hit for for Futures Trade",
      `Stop loss hit for ${formattedData.script}. Exit your trade if taken. Check more details in the application.`,
      14,
      1,
      scriptTypeId,
    );
  }
  else if (stopLossHitTriggered && (scriptTypeId === 3)) {
    // for Options Paid Users
    handleSendNotification(
      2,
      "SL Hit for for Options Trade",
      `Stop loss hit for ${formattedData.script}. Exit your trade if taken. Check more details in the application.`,
      13,
      1,
      scriptTypeId,
    );
  }


  // ======================
  // MANUAL EXIT
  // ======================
  if (manualExitTriggered) {
    // Trade Closed for Equity Paid User
    handleSendNotification(
      2,
      "Trade Closed for Equity",
      `Take exit in ${formattedData.script} at ${formattedData.exitPriceLow} ${formattedData.exitNote}. Check more details in the application.`,
      12,
      1,
      scriptTypeId,
    );
  } else if (manualExitTriggered) {
    // Trade Closed for Futures Paid User
    handleSendNotification(
      2,
      "Trade Closed for Futures",
      `Take exit in ${formattedData.script} at ${formattedData.exitPriceLow} ${formattedData.exitNote}. Check more details in the application.`,
      14,
      1,
      scriptTypeId,
    );
  } else if (manualExitTriggered) {
    // Trade Closed for Options Paid User
    handleSendNotification(
      2,
      "Trade Closed for Options",
      `Take exit in ${formattedData.script} at ${formattedData.exitPriceLow} ${formattedData.exitNote}. Check more details in the application.`,
      13,
      1,
      scriptTypeId,
    );
  }
};
